import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Edit from 'components/inspection_subject/modal/edit';

const EditButton = ({ inspectionSubject, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      variant="contained"
      onClick={() => {
        addModal(
          <Edit
            inspectionSubject={inspectionSubject}
            onSuccess={() => {
              refetch();
              removeModal();
              setInfo('info.inspection_subject.edited');
            }}
            handleClose={() => removeModal()}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        );
      }}
    >
      <FormattedMessage id="button.edit" />
    </Button>
  );
};

export default EditButton;
